import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MainLayout from '../layout/MainLayout'

function Verify(props) {


    const { userHash } = useParams();
    const [isVerified, setIsVerified] = useState(false);


    const verifyUserHash = async () => {
        let url = "/api/v1/auth/verify/" + userHash;
        axios
            .get(url)
            .then((result) => {
                setIsVerified(true);
            }
            )
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        verifyUserHash();
    }, []);

    return (
        <div>
            <MainLayout>
                <div className="text-content">
                    {isVerified &&
                        <div>
                            <p>Your account has been verified. Please log in and enjoy the site.</p>
                            <p>Remember, our basic rule is, treat others like you want to be treated - unless you want to be treated poorly, then you're not welcome.</p>
                        </div>
                    }
                    {!isVerified &&
                        <div>
                            <p>Sorry, we were not able to verify your account.</p>
                        </div>
                    }
                </div>
            </MainLayout>
        </div>
    )
}

export default Verify
